export default "__VITE_ASSET__CV1z0EAc__"